import type { ChangeEvent, RefObject } from 'react';
import React, { forwardRef, useState, type Ref } from 'react';
import { Input } from 'baseui/input';
import { Textarea } from 'baseui/textarea';
import { RadioGroup, Radio, ALIGN } from 'baseui/radio';
const EquationEditor = ({
  equation,
  inline,
  setEquation
}: {
  equation: string;
  inline: boolean;
  setEquation: ({
    equation,
    inline
  }: {
    equation: string;
    inline: boolean;
  }) => void;
}, forwardedRef: Ref<HTMLInputElement | HTMLTextAreaElement>) => {
  const [value, setValue] = useState(inline ? 'inline' : 'block');
  const onOptionChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
    setEquation({
      equation: (forwardedRef as RefObject<HTMLInputElement | HTMLTextAreaElement>).current?.value || '',
      inline: event.target.value === 'inline'
    });
  };
  const onEquationChange = (event: ChangeEvent) => {
    setEquation({
      equation: (event.target as HTMLInputElement).value,
      inline: value === 'inline'
    });
  };
  return <div>
      <RadioGroup align={ALIGN.horizontal} value={value} onChange={onOptionChange}>
        <Radio value="inline">Inline Formula</Radio>
        <Radio value="block">Block Formula</Radio>
      </RadioGroup>
      {value === 'inline' ? <Input value={equation} onChange={onEquationChange} inputRef={(forwardedRef as RefObject<HTMLInputElement>)} positive /> : <Textarea value={equation} onChange={onEquationChange} inputRef={(forwardedRef as RefObject<HTMLTextAreaElement>)} positive />}
    </div>;
};
export default forwardRef(EquationEditor);